import { __ } from '@wordpress/i18n';
import { useEffect } from '@wordpress/element';
import { useBlockProps, InspectorControls } from '@wordpress/block-editor';
import { useSelect } from '@wordpress/data';
import { useEntityProp } from '@wordpress/core-data';
import { TextControl, PanelBody, PanelRow, SelectControl } from '@wordpress/components';

import './editor.scss';

export default function Edit( { attributes, setAttributes } ) {

	const blockProps = useBlockProps();
	const fallbackViewId = useSelect( ( select ) => {
		const postType = select( 'core/editor' ).getCurrentPostType();
		const meta = select( 'core/editor' ).getEditedPostAttribute( 'meta' );
		return meta?._view_id;
	}, [] );

	const _view_id = attributes._view_id || fallbackViewId;

	const viewsList = window.wp_views_block.views;
	const updateViewId = ( newValue ) => {
		setAttributes( { _view_id: newValue } );
	};

	// Initialize attribute from meta once
	useEffect( () => {
		if ( !attributes._view_id && fallbackViewId ) {
			setAttributes( { _view_id: fallbackViewId } );
		}
	}, [ fallbackViewId ] );


	return (
		<>
			<InspectorControls>
				<PanelBody
					title={__( 'WPForms View Details' )}
					initialOpen={true}
				>
					<PanelRow>
						<fieldset>
							<SelectControl
								className="wpf-view-selector"
								label="Select View"
								value={attributes._view_id || ''}
								onChange={updateViewId}
								options={viewsList}
								__nextHasNoMarginBottom
							/>
							<a href={window.wp_views_block.admin_url + 'admin.php?page=wpf-views&view_id=' + _view_id}>Edit View</a>
						</fieldset>
					</PanelRow>

				</PanelBody>
			</InspectorControls>

			<div {...blockProps}>
				<div>
					<h2>WPForms Views</h2>
				</div>
				<SelectControl
					className="wpf-view-selector"
					label=""
					value={attributes._view_id || ''}
					onChange={updateViewId}
					options={viewsList}
				/>

			</div>
		</>
	);
}
